<template>
  <a-sub-menu :key="item.path">
    <template #icon><hhxc-icon :icon="item.meta.icon"></hhxc-icon></template>
    <template #title>{{ item.meta.title.split('-')[0] }}</template>
    <slot></slot>
  </a-sub-menu>
</template>

<script>
  import HhxcIcon from '@/layout/hhxc-icon'
  export default {
    name: 'Submenu',
    components: { HhxcIcon },
    props: {
      item: {
        type: Object,
        default() {
          return null
        },
      },
      routeChildren: {
        type: Object,
        default() {
          return null
        },
      },
    },
  }
</script>
